/** @jsx jsx */

import { Fragment as _, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { CarouselContext } from './Carousel';
import hexToRgb from 'services/hexToRGB';
//

const { lPink } = colors;

const Marker = ({ size = 10, current = false }) => {
  return (
    <div
      css={css`
        position: relative;
        flex-shrink: 0;
        width: ${size}px;
        height: ${size}px;
        margin: 0 5px;
        background: ${current ? lPink : 'transparent'};
        border: 1px solid ${lPink};
        border-radius: 50%;
        transform: scale(${current ? 1.35 : 1});
        transition: all 0.25s;
      `}
    />
  );
};

const Marker_v2 = ({
  size = 15,
  index,
  current = false,
  color = '#959595',
}: {
  size?: number;
  index?: number;
  current?: boolean;
  color?: string;
}) => {
  const carouselContext = useContext(CarouselContext)!;
  const { goto, animate } = carouselContext;

  const isDefaultColor = color === '#959595';

  const { r, g, b } = hexToRgb(color);
  const notCurrentMarkerColor = isDefaultColor
    ? 'rgba(73,73,73,1)'
    : `rgba(${r}, ${g}, ${b}, 0.5)`;

  return (
    <div
      css={css`
        position: relative;
        flex-shrink: 0;
        width: ${size}px;
        height: ${size}px;
        margin: 0 5px;
        background: ${current ? color : notCurrentMarkerColor};
        border-radius: 50%;
        ${animate && 'transition: all 0.25s;'}

        ${!current &&
          `
          cursor: pointer;
          &:hover {
            background: ${color};
          }
        `}

        @media (max-width: 480px) {
          top: 5px;
          width: ${size / 2}px;
          height: ${size / 2}px;
        }
      `}
      onClick={e => {
        !current && goto(index!);
      }}
      aria-label={`Go to slide ${index! + 1}`}
      // aria-pressed={current}
      role="button"
    />
  );
};

export default Marker_v2;
